/**
 * @flow
 * @relayHash ab3c34119f97d078aa6a151c3ad87286
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SearchPageContainer_app$ref = any;
type SearchPageContainer_user$ref = any;
export type SearchViewQueryVariables = {|
  userId: string
|};
export type SearchViewQueryResponse = {|
  +app: ?{|
    +$fragmentRefs: SearchPageContainer_app$ref
  |},
  +user: ?{|
    +$fragmentRefs: SearchPageContainer_user$ref
  |},
|};
export type SearchViewQuery = {|
  variables: SearchViewQueryVariables,
  response: SearchViewQueryResponse,
|};
*/


/*
query SearchViewQuery(
  $userId: String!
) {
  app {
    ...SearchPageContainer_app
    id
  }
  user(userId: $userId) {
    ...SearchPageContainer_user
    id
  }
}

fragment SearchPageContainer_app on App {
  moneyRaised
  ...MoneyRaisedContainer_app
}

fragment SearchPageContainer_user on User {
  id
}

fragment MoneyRaisedContainer_app on App {
  moneyRaised
  dollarsPerDayRate
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchViewQuery",
  "id": null,
  "text": "query SearchViewQuery(\n  $userId: String!\n) {\n  app {\n    ...SearchPageContainer_app\n    id\n  }\n  user(userId: $userId) {\n    ...SearchPageContainer_user\n    id\n  }\n}\n\nfragment SearchPageContainer_app on App {\n  moneyRaised\n  ...MoneyRaisedContainer_app\n}\n\nfragment SearchPageContainer_user on User {\n  id\n}\n\nfragment MoneyRaisedContainer_app on App {\n  moneyRaised\n  dollarsPerDayRate\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchViewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchPageContainer_app",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SearchPageContainer_user",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchViewQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "app",
        "storageKey": null,
        "args": null,
        "concreteType": "App",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "moneyRaised",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "dollarsPerDayRate",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": v1,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v2
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f868bc12382c2dc381d46732c7f0fd00';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Search/__generated__/SearchViewQuery.graphql.js